import { History } from "lucide-react";

import TranscriptDivider from "./TranscriptDivider";

const LABEL = "Earlier messages summarised for the agent";

/** Where the agent's memory of a chat now starts: everything above reaches the agent as one
    summary, made once when the chat outgrew its model's window. The people still see all of
    it. The platform chat, the client app and the extension draw it alike (DESIGN.md §5). */
export default function SummaryDivider() {
  return (
    <TranscriptDivider icon={History} label={LABEL} title="The agent reads a summary of everything above. Everyone here still sees all of it.">
      {LABEL}
    </TranscriptDivider>
  );
}
